var map = {
	"./compliance_ledger.webp": 79478,
	"./crisis_management.webp": 74046,
	"./data_leak.webp": 32689,
	"./data_sanitization.webp": 53387,
	"./insurance.webp": 11123,
	"./telemedicine.webp": 10517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43845;